export const grey = '#595850'
export const red = '#F03232'



// WEBPACK FOOTER //
// ./src/styles/colors.js